import { Navigate, Route, Routes } from "react-router";
import { RequireAdmin } from "@features/auth/components/require-admin";
import { RequireSession } from "@features/auth/components/require-session";
import { LoginPage } from "@features/auth/pages/login-page";
import { BrandPage } from "@features/brands/pages/brand-page";
import { CorporatePerformancePage } from "@features/corporate/pages/corporate-performance-page";
import { MyJobPage } from "@features/brands/pages/my-job-page";
import { StaffPage } from "@features/auth/pages/staff-page";
import { GlobalMenuPage } from "@features/global-menu/pages/global-menu-page";
import { SettingLayout } from "@features/settings/components/setting-layout";
import { GroupDetailPage } from "@features/settings/pages/group-detail-page";
import { FinanceDocPage } from "@features/settings/pages/finance-doc-page";
import { ProjectCodePage } from "@features/settings/pages/project-code-page";
import { GroupListPage } from "@features/settings/pages/group-list-page";
import { ProductDetailPage } from "@features/settings/pages/product-detail-page";
import { ProductListPage } from "@features/settings/pages/product-list-page";

export function AppRoutes() {
  return (
    <Routes>
      {/* หน้าเดียวที่เข้าได้โดยไม่มี credential */}
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <RequireSession>
            <MyJobPage />
          </RequireSession>
        }
      />
      <Route
        path="/corporate-performance"
        element={
          <RequireAdmin>
            <CorporatePerformancePage />
          </RequireAdmin>
        }
      />
      {/* ไม่ระบุเมนู = Overview ซึ่งเป็นหน้า default ของแบรนด์ */}
      <Route
        path="/brand/:brandId"
        element={
          <RequireSession>
            <BrandPage />
          </RequireSession>
        }
      />
      <Route
        path="/brand/:brandId/:menuId"
        element={
          <RequireSession>
            <BrandPage />
          </RequireSession>
        }
      />
      <Route
        path="/brand/:brandId/:menuId/:sub"
        element={
          <RequireSession>
            <BrandPage />
          </RequireSession>
        }
      />
      <Route path="/setting" element={<Navigate to="/setting/product" replace />} />
      <Route
        path="/setting/product"
        element={
          <RequireAdmin>
            <SettingLayout activeMenuId="product">
              <ProductListPage />
            </SettingLayout>
          </RequireAdmin>
        }
      />
      <Route
        path="/setting/product/:code"
        element={
          <RequireAdmin>
            <SettingLayout activeMenuId="product">
              <ProductDetailPage />
            </SettingLayout>
          </RequireAdmin>
        }
      />
      <Route
        path="/setting/group"
        element={
          <RequireAdmin>
            <SettingLayout activeMenuId="group">
              <GroupListPage />
            </SettingLayout>
          </RequireAdmin>
        }
      />
      <Route
        path="/setting/group/:id"
        element={
          <RequireAdmin>
            <SettingLayout activeMenuId="group">
              <GroupDetailPage />
            </SettingLayout>
          </RequireAdmin>
        }
      />
      <Route
        path="/setting/staff"
        element={
          <RequireAdmin>
            <SettingLayout activeMenuId="staff">
              <StaffPage />
            </SettingLayout>
          </RequireAdmin>
        }
      />
      <Route
        path="/setting/financedoc"
        element={
          <RequireAdmin>
            <SettingLayout activeMenuId="financedoc">
              <FinanceDocPage />
            </SettingLayout>
          </RequireAdmin>
        }
      />
      <Route
        path="/setting/projectcode"
        element={
          <RequireAdmin>
            <SettingLayout activeMenuId="projectcode">
              <ProjectCodePage />
            </SettingLayout>
          </RequireAdmin>
        }
      />
      <Route
        path="/setting/globalmenu"
        element={
          <RequireAdmin>
            <SettingLayout activeMenuId="globalmenu">
              <GlobalMenuPage />
            </SettingLayout>
          </RequireAdmin>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
